<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />

    <example-title src="example-1.html" title="Configurable notifications demo (open the console)" />
    <vc-layout :spacing="8">
      <vc-col :span="12" md24>
        <h4 :class="configHeading">Notification text</h4>
        <vc-text :color="controlsColor" name="text" v-model="text" />
        <h4 :class="configHeading">Notification icon</h4>
        <vc-button-group :disabled="!useIcon" :color="controlsColor" size="small" type="exclusive" name="exclusive" v-model="icon">
          <vc-button v-for="(icon, index) in icons" :name="icon" :key="index">
            <vc-icon>{{ icon }}</vc-icon>
          </vc-button>
        </vc-button-group>
        <vc-checkbox :color="controlsColor" name="use-icon" v-model="useIcon">use icon</vc-checkbox>
        <h4 :class="configHeading">Manual close</h4>
        <vc-checkbox :color="controlsColor" name="dismissable" v-model="dismissable">allow manual dismiss</vc-checkbox>
        <h4 :class="configHeading">Horizontal position</h4>
        <vc-radio-group :color="controlsColor" name="horizontal" direction="horizontal" v-model="horizontal">
          <vc-radio value="right">right</vc-radio>
          <vc-radio value="left">left</vc-radio>
        </vc-radio-group>
      </vc-col>
      <vc-col :span="12" md24>
        <h4 :class="configHeading">Close delay</h4>
        <vc-select :color="controlsColor" name="delay" v-model="delay" :items="delays" />
        <h4 :class="configHeading">Color</h4>
        <vc-radio-group :color="controlsColor" name="color" v-model="color" direction="horizontal">
          <vc-radio v-for="(color, index) in colors" :value="color" :key="index">{{ color }}</vc-radio>
        </vc-radio-group>
        <h4 :class="configHeading">Theme</h4>
        <vc-switcher :color="controlsColor" name="dark" v-model="dark">dark/light theme</vc-switcher>
        <h4 :class="configHeading">Vertical position</h4>
        <vc-radio-group :color="controlsColor" name="vertical" direction="horizontal" v-model="vertical">
          <vc-radio value="top">top</vc-radio>
          <vc-radio value="middle">middle</vc-radio>
          <vc-radio value="bottom">bottom</vc-radio>
        </vc-radio-group>
      </vc-col>
    </vc-layout>
    <vc-button block :color="controlsColor" @click="notify()">Show Notification</vc-button>
    <vc-notification
      @added="onAdded($event)"
      @removed="onRemoved($event)"
      :vertical="vertical"
      :horizontal="horizontal"
      :name="notification" />
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'NotificationPage',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null,
      dismissable: true,
      dark: true,
      vertical: 'bottom',
      horizontal: 'right',
      notificationNumber: 1,
      useIcon: true,
      configHeading: ['subheading', 'font-grey', 'font-l-600', 'mx-0', 'my-8'],
      controlsColor: 'indigo',
      text: 'I am a notification',
      icons: [
        'notifications',
        'notifications_active',
        'notifications_none',
        'notifications_off',
        'notifications_paused'
      ],
      colors: [
        'primary',
        'success',
        'warning',
        'error'
      ],
      color: 'primary',
      delay: [],
      delays: [],
      notification: 'notification-1'
    }
  },
  created () {
    let i = 1
    const delays = []
    while (i < 11) {
      delays.push({
        label: `${i} second${i === 1 ? '' : 's'}`,
        value: `${i}000`
      })
      i++
    }
    this.delays = delays
    this.delay.push(delays[4])
    this.icon = [this.icons[0]]
  },
  mounted () {
    this.getPage()
  },
  methods: {
    onAdded (data) {
      console.log('vc-notification:added', data)
    },
    onRemoved (data) {
      console.log('vc-notification:removed', data)
    },
    notify () {
      this.$root.$emit('vc:notification', {
        icon: this.useIcon ? this.icon[0] : null,
        text: `${this.text} (#${this.notificationNumber})`,
        delay: this.delay[0].value,
        color: this.color,
        dismissable: this.dismissable,
        dark: this.dark,
        name: this.notification
      })
      this.$nextTick(() => {
        this.notificationNumber++
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/notification.vue